/**
 * Get nested value from object using dot notation
 * @param obj - The object to search in
 * @param path - The path string (e.g., 'product.item_name')
 * @returns The value at the path or undefined
 */
export function getNestedValue(obj: Record<string, unknown>, path: string): unknown {
  if (!obj || !path) return undefined

  const keys = path.split('.')
  let value: unknown = obj

  for (const key of keys) {
    if (value === null || value === undefined) return undefined
    value = (value as Record<string, unknown>)[key]
  }

  return value
}
